import { render, staticRenderFns } from "./RejeitadaSelo.vue?vue&type=template&id=6ba640ea&scoped=true"
import script from "./RejeitadaSelo.vue?vue&type=script&lang=js"
export * from "./RejeitadaSelo.vue?vue&type=script&lang=js"
import style0 from "./RejeitadaSelo.vue?vue&type=style&index=0&id=6ba640ea&prod&lang=css"
import style1 from "./RejeitadaSelo.vue?vue&type=style&index=1&id=6ba640ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba640ea",
  null
  
)

export default component.exports